import React from 'react'
import { IoCloseSharp } from 'react-icons/io5'
import styled from 'styled-components'
import { Text } from 'lib/Text'
import { SearchInput } from './SearchInput'
import { useAlgoliaSearchContext } from './controllers/AlgoliaSearchContext'

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 4px;
  height: 44px;
  margin-bottom: 12px;
  flex-shrink: 0;
`

const CloseButton = styled.button`
  appearance: none;
  background: none;
  color: var(--black-100);
  padding: 0;
  border: none;
  display: inline-flex;
  align-items: center;
`

const InputContainer = styled.div`
  z-index: 10;
  padding-bottom: 1px;
  box-shadow: #ffffff 0px 10px 12px 2px;
`

export const SearchModalMobileHeader = () => {
  const { closeModal } = useAlgoliaSearchContext()

  return (
    <>
      <Header>
        <Text size="s" weight="medium">
          Search
        </Text>
        <CloseButton
          onClick={() => {
            closeModal()
          }}>
          <IoCloseSharp size={32} />
        </CloseButton>
      </Header>
      <InputContainer>
        <SearchInput />
      </InputContainer>
    </>
  )
}
